import { gsap } from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {SplitText} from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)

export default class Animations {
  static init() {
    console.debug('== Animations components ==')

    const main = document.querySelector('.main-wrapper')

    // Homepage hero animation
    if (main.classList.contains('front-page')) {
      console.debug('  -> Animate main viewport')

      const headerWrapper = document.querySelector('.header-wrapper')
      const sectionHero = document.querySelector('.section--hero')

      const tlMainViewport = gsap.timeline()
      tlMainViewport
        .from(sectionHero, {
          autoAlpha: 0,
          delay: 0.125,
          duration: 1,
          ease: 'expo.out',
        })
        .from(headerWrapper, {
          autoAlpha: 0,
          delay: -0.725,
          duration: 1,
          ease: 'expo.out',
        })
    }

    // General animations
    console.debug('  -> Animate general components')

    const animateRight = document.querySelectorAll('.animate-right')
    if (animateRight.length != 0) {
      animateHorizontal(animateRight, 20)
    }

    const animateLeft = document.querySelectorAll('.animate-left')
    if (animateLeft.length != 0) {
      animateHorizontal(animateLeft, -20)
    }

    const animateBottom = document.querySelectorAll('.animate-bottom')
    if (animateBottom.length != 0) {
      animateVertical(animateBottom, 20)
    }

    const animateTop = document.querySelectorAll('.animate-top')
    if (animateTop.length != 0) {
      animateVertical(animateTop, -20)
    }

    const animateFadeItems = document.querySelectorAll('.animate-fade')
    if (animateFadeItems.length != 0) {
      animateFade(animateFadeItems)
    }

    const animateBottomStaggerProducts = document.querySelectorAll('.animate-bottom-stagger-product')
    if (animateBottomStaggerProducts.length != 0) {
      animateBottomStagger(animateBottomStaggerProducts, 20, 0.15)
    }

    // const animateBottomStaggerImages = document.querySelectorAll('.animate-bottom-stagger-image')
    // if (animateBottomStaggerImages.length != 0) {
    //   animateBottomStagger(animateBottomStaggerImages, 20, 0.15)
    // }
  }

  static destroyScrolls() {
    ScrollTrigger.killAll()
  }
}

function animateHorizontal(items, offset) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({paused: true})

    tlItem.from(item, {
      autoAlpha: 0,
      duration: 1,
      x: offset,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 85%',
      end: 'bottom 85%',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none reverse',
    })
  })
}

function animateVertical(items, offset, start = 'top 95%') {
  items.forEach((item) => {
    let tlItem = gsap.timeline({paused: true})

    tlItem.from(item, {
      autoAlpha: 0,
      duration: 1,
      y: offset,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: start,
      end: 'bottom 90%',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none reverse',
    })
  })
}

function animateFade(items) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({paused: true})

    tlItem.from(item, {
      autoAlpha: 0,
      duration: 1,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 95%',
      end: 'bottom 90%',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none reverse',
    })
  })
}

function animateBottomStagger(items, offset, stagger) {
  let tlItem = gsap.timeline({paused: true})

  tlItem.from(items, {
    autoAlpha: 0,
    duration: 1,
    y: offset,
    ease: 'expo.out',
    stagger: stagger,
    delay: 0.25,
  })

  ScrollTrigger.create({
    trigger: items,
    start: 'top 95%',
    end: 'bottom 90%',
    animation: tlItem,
    markers: false,
    toggleActions: 'play none none reverse',
  })
}
